import axios from "axios";
import { API_BASE } from "../config/constants";

export const pageSettingsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/settings`,
});

export const executiveProgramResource = axios.create({
  baseURL: `${API_BASE}/api/v1/executive-program`,
});

export const executiveExhibitorsTagResource = (url) =>
  axios.create({
    baseURL: `${url}/api/external/event/virtual-exhibition-tags`,
  });

export const executiveExhibitorsResource = (url, eventId) =>
  axios.create({
    baseURL: `${url}/api/external/event/${eventId}/virtual-exhibition-data`,
  });

export const pageTypeResource = axios.create({
  baseURL: `${API_BASE}/api/v1/pageType`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const sponsorGroupResource = axios.create({
  baseURL: `${API_BASE}/api/v1/sponsor-group`,
});

export const sponsorViewResource = axios.create({
  baseURL: `${API_BASE}/api/v1/sponsor/view`,
});

export const validateWebinarCodeResource = axios.create({
  baseURL: `${API_BASE}/api/v1/webinar/validate`,
});

export const requestWebinarCodeResource = axios.create({
  baseURL: `${API_BASE}/api/v1/webinar/request`,
});

export const webinarScheduleResource = axios.create({
  baseURL: `${API_BASE}/api/v1/event-schedule`,
});

export const boothResource = axios.create({
  baseURL: `${API_BASE}/api/v1/booths`,
});
